import { get } from 'lodash';

const DOLLAR_UNIT = 'dollar';
const SERVICE_PROVIDED_CATEGORY = 'service_provided';

export const getInteractionDateParts = (interactionDate = {}) => ({
  day: get(interactionDate, 'day', ''),
  month: get(interactionDate, 'month', ''),
  year: get(interactionDate, 'year', ''),
  time: get(interactionDate, 'time', ''),
});

export const getProcessedNoteMetadata = (note = {}) => ({
  type: get(note, '_processedNoteType', ''),
  added: get(note, '_processedAdded', ''),
  date: get(note, '_processedDate', ''),
});

export const getNoteDate = (category, details = {}) => get(
  details,
  category === SERVICE_PROVIDED_CATEGORY ? 'service_provided.date' : 'interaction.date',
  '',
);

export const getServiceProvidedData = (details = {}) => {
  const serviceProvided = get(details, 'service_provided', null);

  if (!serviceProvided) {
    return {
      serviceProvided: null,
      serviceProvidedType: '',
      serviceProvidedAmount: '',
      serviceProvidedUnit: '',
    };
  }

  const serviceProvidedAmount = get(serviceProvided, 'amount', '');
  const unit = get(serviceProvided, 'unit', '');

  return {
    serviceProvided,
    serviceProvidedType: get(serviceProvided, 'type', ''),
    serviceProvidedAmount,
    serviceProvidedUnit: unit === DOLLAR_UNIT && serviceProvidedAmount > 1 ? `${unit}s` : unit,
  };
};

export const shouldShowDeleteButton = ({ showDeleteNoteIcon, currentEmployeeId, note = {} }) => (
  showDeleteNoteIcon && currentEmployeeId === get(note, 'employee.id')
);

export const isNoteDeletable = (details = {}) => get(details, 'deletable', true);

export const shouldShowReason = (reason, details = {}) => Boolean(reason && get(details, 'context', null));
